/**
 * The DELETE endpoint returns 204 No Content; `performHttpFetch` would
 * attempt `response.json()` and throw on an empty body, so we use the
 * manual `fetch` here instead.
 */
import { FetchError } from '@atlassian/conversation-assistant-utils/httpUtils';

import { SPACES_API_PATH } from '../../common/constants';

export type DeleteSpaceMemoryFetchParams = {
	spaceId: string;
	memoryId: string;
	cloudId: string;
	product: string;
	experienceId: string;
};

export const deleteSpaceMemoryFetchAction = async ({
	spaceId,
	memoryId,
	cloudId,
	product,
	experienceId,
}: DeleteSpaceMemoryFetchParams): Promise<void> => {
	const path = `${SPACES_API_PATH}/${spaceId}/memory/${memoryId}`;
	let response: Response;
	try {
		response = await fetch(path, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				'x-cloudid': cloudId,
				'x-product': product,
				'x-experience-id': experienceId,
			},
			credentials: 'include',
		});
	} catch (err) {
		const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
		throw new FetchError(
			`deleteSpaceMemoryFetch error while fetching ${path}. Original error: ${originalErrorMessage}`,
			{ errorCode: 'deleteSpaceMemoryFetchError' },
		);
	}
	if (!response.ok || response.status >= 400) {
		const body = await response.text().catch(() => '');
		throw new FetchError(
			`deleteSpaceMemoryFetch error while fetching ${path}. Original error: [Code ${response.status}] ${body}`,
			{ errorCode: 'deleteSpaceMemoryFetchError', statusCode: response.status },
		);
	}
	// 204 No Content — no body to parse.
};
